// extracted by mini-css-extract-plugin
export default {"get_in_touch":"qs","title":"rs","subtitle":"ss","buttons":"ts","btn":"us","copy":"vs"};
    if(module.hot) {
      // 1713361643821
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  